import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './quotes-promo-modal.module.css';

interface Props {
    onClose: () => void;
}

export function QuotesPromoSuccessStep(props: Props) {
    return (
        <div className={styles.wrapper}>
            <div className={styles['main-content']}>
                <Stack spacing={16}>
                    <Body isBold={true} size='xlarge' color='dark' useDoyle={true}>
                        Awesome, your team now has Quotes & Invoices
                    </Body>
                    <Body size='large'>We are so excited to see your company grow.</Body>
                    <Body size='large'>
                        If you’d like to learn how to get more out of Quotes & Invoices, view our{' '}
                        <Link
                            href='https://support.nutshell.com/en/articles/10616834-nutshell-quotes-guide'
                            newTab={true}
                            variant='primary'
                            size='big'
                        >
                            knowledge base article.
                        </Link>
                    </Body>
                </Stack>
            </div>
            <div className={styles.footer}>
                <Button variant='text-secondary' onClick={props.onClose}>
                    Back to the Explore page
                </Button>
                <Link
                    variant='button-primary'
                    size='big'
                    to='/sales/quote-template'
                    // @ts-expect-error
                    as={RoutedLink}
                >
                    Go to Quotes & Invoices
                </Link>
            </div>
        </div>
    );
}
